import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import tick from "assets/images/tick.gif"
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState } from "react";
import MDBackdrop from "components/MDBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useMaterialUIController } from "context";
import theme from "assets/theme";


function Completion(props) {
    const [isDisabled, setIsDisabled] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { onClose } = props;


    const handleClose = () => {
        onClose(false);
    };
    const pop = () => {
        setIsBackdrop(false);
        onClose(false);
        setIsDisabled(!isDisabled);
    };

    return (
        <>
    
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "flex-end" } : { theme, display: "flex", alignItems: "center", justifyContent: "flex-end" }}>

                    <IconButton aria-label="delete" style={darkMode ? { color: "#ffffff" } : theme} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} style={{ display: "flex",flexDirection : "column",alignItems:"center", justifyContent: "center", height: "50vh" }}>
                        <img src={tick} alt="User Created successfully!!" />
                        <MDBox>
                            Transaction has
                            been successfully started
                        </MDBox>
         
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>
                    <MDButton variant="gradient" color="info"
                        
                        onClick={pop}
                    >
                        View transaction
                    </MDButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Completion;